import { HTTPServiceClient } from '@/packages/http/service';
import * as t from './endpoints';
import {
  FetchMrtRequest,
  MachineReadableTemplate,
  MrtTemplateRequest,
  MrtUrlResponse,
  PaginatedResult,
  UploadMachineReadableRequest
} from './types';

/**
 * --------------------------------------------------
 *	Machine Readable Template HTTP Service
 * --------------------------------------------------
 **/
export const MrtService = {
  fetchMachineReadableTemplates(
    requestParams: FetchMrtRequest
  ): Promise<PaginatedResult> {
    return HTTPServiceClient.get(
      t.FETCH_MACHINE_READABLE_TEMPLATES(requestParams)
    ).then(({ data }) => data);
  },
  uploadMachineReadableTemplates(
    requestParams: UploadMachineReadableRequest
  ): Promise<MachineReadableTemplate> {
    let formData = new FormData();
    formData.append('file', requestParams.file, requestParams.file.name);
    formData.append('clientId', requestParams.clientId);
    formData.append('reportingPeriodId', requestParams.reportingPeriodId);

    if (requestParams.portfolioId) {
      formData.append('portfolioId', requestParams.portfolioId);
    }

    if (requestParams.subfundId) {
      formData.append('subfundId', requestParams.subfundId);
    }

    return HTTPServiceClient.post(
      t.UPLOAD_MACHINE_READABLE_TEMPLATES(requestParams),
      formData
    ).then(({ data }) => data?.data);
  },

  downloadMachineReadableTemplate(
    requestParams: MrtTemplateRequest
  ): Promise<MrtUrlResponse> {
    return HTTPServiceClient.get(
      t.DOWNLOAD_MACHINE_READABLE_TEMPLATE(requestParams)
    ).then(({ data }) => data);
  },

  downloadMachineReadableTemplateErrorFile(
    requestParams: MrtTemplateRequest
  ): Promise<MrtUrlResponse> {
    return HTTPServiceClient.get(
      t.DOWNLOAD_MACHINE_READABLE_TEMPLATE_ERROR_FILE(requestParams)
    ).then(({ data }) => data);
  }
};
